import { format, setHours, startOfToday } from 'date-fns';

const hours = Array.from({ length: 24 }, (_, i) => i);

const minutes = Array.from({ length: 12 }, (_, i) => i * 5);

const baseDate = startOfToday();

export const hoursOptions = hours.map(hour => {
  const date = setHours(baseDate, hour);

  return {
    text: format(date, 'h aa'),
    value: hour,
  };
});

export const minutesOptions = minutes.map(minute => ({
  text: minute.toString(),
  value: minute,
}));
